var React = require('react');

function ExpandButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.133,58.65,8,64.866,1.867,58.65,0,60.542,8,68.65l8-8.108Z","transform":"translate(0 -58.65)","fill":"#941d35"}));
}

ExpandButton.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10"};

module.exports = ExpandButton;

ExpandButton.default = ExpandButton;
